import axios from 'axios';
import Vue from 'vue';
import { formatearDireccionGoogle } from '@/utils/funciones_auxiliares.js';

export default {
    setNegocioPedido(state, n) {
        state.negocioPedido = n;
        localStorage.setItem('negocioPedido', n)
    },
    setNegocioObjPedido(state, obj) {
        state.negocioObjPedido = obj;
    },
    setRestaurantePedido(state, r) {
        state.restaurantePedido = r;
        localStorage.setItem('activeRestId', r)
    },
    setRestauranteObjPedido(state, obj) {
        state.restauranteObjPedido = obj;
    },
    setContinuarPedido(state, b) {
        state.continuarPedido = b;
    },
    setPedidoPendienteCarrito(state, c) {
        state.pedidoPendiente.carrito = c;
    },
    setPedidoPendientePedido(state, c) {
        state.pedidoPendiente.pedido = c;
    },
    setPedidoPendienteRestaurante(state, c) {
        state.pedidoPendiente.restaurante = c;
    },
    setPedidoPendienteRestauranteObj(state, c) {
        state.pedidoPendiente.restauranteObj = c;
    },
    setPedidoPendienteNegocio(state, c) {
        state.pedidoPendiente.negocio = c;
    },
    setPedidoPendienteNegocioObj(state, c) {
        state.pedidoPendiente.negocioObj = c;
    },
    setPedidoPendienteDireccion(state, c) {
        state.pedidoPendiente.direccion = c;
    },
    setDireccionPedido(state, objDir) {
        state.direccionPedido = objDir;
        localStorage.setItem('dirPidiendo', JSON.stringify(objDir));
    },
    pedidoPendienteToEnCurso(state) {
        state.activePedido.forma_envio = state.pedidoPendiente.pedido.forma_envio;
        state.direccionPedido = state.pedidoPendiente.direccion;
        //state.pedido =
        state.restaurantePedido = state.pedidoPendiente.restaurante;
        state.negocioPedido = state.pedidoPendiente.negocio; //es id de negocio 
        if (state.pedidoPendiente.carrito) {
            state.carrito = state.pedidoPendiente.carrito
        }
    },
    pedidoCompararToEnCurso(state) {
        console.log(state.datosCompararNuevo)
        state.activePedido.forma_envio = state.datosCompararNuevo.forma_envio;
        //state.direccionPedido = state.pedidoPendiente.direccion;
        //state.pedido =
        state.restaurantePedido = state.datosCompararNuevo.restaurante;
        state.negocioPedido = state.datosCompararNuevo.negocio; //es id de negocio 
    },
    resetPedidoPendiente(state) {
        state.pedidoPendiente = {
            pedido: '',
            restaurante: '',
            restauranteObj: { nombre: '' },
            negocioObj: { nombre: '' },
            negocio: '',
            direccion: '',
            carrito: ''
        }
        localStorage.removeItem('shoppingCart')
        localStorage.removeItem('activePedido');
        localStorage.removeItem('negocioPedido');
        localStorage.removeItem('activeRestId');
    },
    setDatosCompararNuevo(state, datos) {
        state.datosCompararNuevo = datos;
    },
    setUltimosPedidos(state, pedidos) {
        state.ultimosPedidos = pedidos;
    },
    setCarritoComprobadoServidorCambiado(state, b) {
        state.carritoComprobadoServidorCambiado = b;
    },
    setCarritoComprobadoServidor(state, c) {
        state.carritoComprobadoServidor = c;
        state.carritoComprobadoServidorCambiado = true;
    },
    carritoComprobadoToPedido(state) {
        state.carrito.productos = state.carritoComprobadoServidor.productos;
        state.carrito.numero_producto = state.carritoComprobadoServidor.numero_producto;
        state.carrito.precio_total = state.carritoComprobadoServidor.precio_total;
        //state.carritoComprobadoServidorCambiado = false;
    },
    //nuevo
    setCarrito(state, carrito) {
        const filtroVacios = (carrito.productos) ? carrito.productos.filter(e => e.cantidad >= 1) : [];
        carrito.productos = filtroVacios;
        state.carrito = carrito;
        localStorage.setItem('shoppingCart', JSON.stringify(state.carrito));
    },
    addProducto(state, products) {
        const filtroVacios = products.filter(e => e.cantidad >= 1);
        const reducer = (accumulator, currentValue) => accumulator + currentValue;

        let cart = state.carrito;
        cart.productos = filtroVacios;
        /*********************************** Construye el precio y cantidad totales ***********************************/
        cart.precio_total = 0;
        cart.numero_producto = 0;

        products.forEach(function (e) {
            let sumaOpciones = 0;
            if (e.opcionesPrecio.length > 0) sumaOpciones = e.opcionesPrecio.reduce(reducer);

            cart.precio_total += e.cantidad * (e.precio + sumaOpciones)
            cart.numero_producto += e.cantidad
        })

        state.carrito = cart;
        localStorage.setItem('shoppingCart', JSON.stringify(state.carrito));
    },
    setLoadingCarrito(state, bool) {
        state.loadingCarrito = bool;
    },
    setLoadingFinalizar(state, bool) {
        state.loadingFinalizar = bool;
    },
    setLoadingQuantity(state, bool) {
        state.loadingQuantity = bool;
    },
    setActiveCat(state, cat) {
        state.activeCat = cat;
    },
    setActiveProduct(state, prod) {
        state.activeProduct = prod;
        //state.activeProduct.dialog = true;
    },
    setActivProductOpciones(state, op) {
        state.opcionesActiveProduct = op;
        state.activeProductDialogActivo = 0;
        //Vue.set(state.activeProduct, opciones, op);
    },
    setActivProductDialogActivo(state, dialog) {
        state.activeProductDialogActivo = dialog;
    },
    setLoadOptions(state, bool) {
        state.loadOptions = bool;
    },
    setLoadingDialog(state, bool) {
        state.loadingDialog = bool;
    },
    setStripeDialog(state, bool) {
        state.stripeDialog = bool;
    },
    setConfirmarPagoDialog(state, bool) {
        state.confirmarPagoDialog = bool;
    },
    setActiveProductDialog(state, bool) {
        state.activeProductDialog = bool;
    },
    setDialogDireccion(state, bool) {
        state.dialogDireccion = bool;
    },
    nextDialog(state) {
        state.movimientoDialog = 'avanza';
        state.activeProductDialogActivo++;
    },
    lastDialog(state) {
        state.movimientoDialog = 'retrocede';
        state.activeProductDialogActivo--;
    },
    setDialogCambioCarrito(state, val) {
        state.dialogCambioCarrito = val;
    },
    addOpcion(state, opciones) {
        state.seleccionOpciones = opciones;
    },
    setActivePedido(state, pedido) {
        state.activePedido = pedido;
        localStorage.setItem('activePedido', JSON.stringify(state.activePedido));
    },

    setModo(state, modo) {
        if (state.activePedido) {
            state.activePedido.forma_envio = modo;
        } else {
            state.activePedido = {
                forma_envio: modo
            }
        }
        if (modo == 'recoger') {
            state.pedidoMinimo = 0;
            localStorage.setItem('pedidoMinimo', 0);
            state.recargoPedido = 0;
            localStorage.setItem('recargo', 0);
        }
        localStorage.setItem('activePedido', JSON.stringify(state.activePedido));
    },
    setFormaPago(state, pago) {
        if (state.activePedido) {
            Vue.set(state.activePedido, 'forma_pago', pago);
        } else {
            state.activePedido = {
                forma_pago: pago
            }
            Vue.set(state.activePedido, 'forma_pago', pago);
        }
        localStorage.setItem('activePedido', JSON.stringify(state.activePedido));
    },
    setUsuarioConfirmado(state, value) {
        state.usuarioConfirmado = value;
    },
    setCambio(state, val) {
        if (state.activePedido) {
            state.activePedido.cambio = val;
        } else {
            state.activePedido = {
                cambio: val
            }
        }
        localStorage.setItem('activePedido', JSON.stringify(state.activePedido));
    },
    setProducts(state, data) {
        state.products.push(data);
    },
    setModalProduct(state, data) {
        if (state.activeProduct) {
            state.activeProduct.modal = data;
        }
    },
    productDialogOpenClose(state, boolean) {
        state.activeProduct.dialog = boolean;
    },
    setDialogModoTotem(state, boolean) {
        state.dialogModoTotem = boolean;
    },
    reorderRestaurants(state, data) {
        state.listadoRestaurantes = data;
    },
    setNavigatorAddress(state, data) {
        state.navigatorAddress = data;
    },
    checkCompatibilidades(state) {
        console.log("check")
    },
    setPasoFinalizar(state, n) {
        state.pasoFinalizar = n
    },
    nextPasoFinalizar(state) {
        state.pasoFinalizar++
    },
    previousPasoFinalizar(state) {
        state.pasoFinalizar--
    },
    resetCarrito(state) {
        localStorage.removeItem('shoppingCart');
        state.carrito = {
            productos: [],
            numero_producto: 0
        }
        state.confirmarPagoDialog = false;
    },
    setCambioCarrito(state, val) {
        state.cambioCarrito = val;
    },
    resetActiveProduct(state) {
        state.loadOptions = false;
        state.activeProduct = {
            img: '',
            name: '',
            prize: 0,
        };
        state.opcionesActiveProduct = false;
        state.activeProductDialogActivo = null;
        state.seleccionOpciones = [];

    },
    resetActivePedido(state) {
        state.activePedido = { modo: '', forma_pago: '', modo_preparacion: '', nota: '' };
        state.continuePedido = false;
        state.carrito = {
            productos: [],
            numero_producto: 0
        };
        state.continuePedido = false;
        localStorage.removeItem('activePedido');
        state.restaurantePedido = null;

        state.restauranteObjPedido = {};
        localStorage.removeItem('activeRestId');
    },
    resetActivePedidoNegocio(state) {
        state.negocioPedido = null;
        state.negocioObjPedido = {
            imagenListado: "",
            nombre: "",
            imagen: ""
        };
    },

    actualizarNota(state, data) {
        if (state.activePedido) {
            state.activePedido.nota = data;
        } else {
            state.activePedido = {
                nota: data
            }
        }
    },
    setAddressObjectByType(state, data) {
        state.addressObject[data[0]] = data[1];
    },
    setAddressObjectCoordenadas(state, data) {
        state.addressObject.coordenadas = data;
    },
    setCodigoProvincia(state, data) {
        state.addressObject.codigoProvincia = data;

        if (state.codigoProvinciaAnterior != data) {
            state.codigoProvinciaAnterior = data;
            state.codigoProvinciaDiferente = true;

        } else {
            state.codigoProvinciaDiferente = false;

        }
    },
    cleanAddressObject(state) {
        state.addressObject = {
            calle: '',
            numero: '',
            adicional: '',
            cp: '',
            municipio: '',
            provincia: '',
            pais: '',
            codigoPais: '',
            coordenadas: []
        }
    },
    setAddressObjectSinFiltro(state, dir) {
        state.addressObject = dir;
    },
    setAddressObject(state, data) {
        let dir = formatearDireccionGoogle(data);

        state.addressObject.calle = dir.calle;
        state.addressObject.numero = dir.numero;
        state.addressObject.adicional = dir.adicional;
        state.addressObject.cp = dir.cp;
        state.addressObject.municipio = dir.municipio;
        state.addressObject.provincia = dir.provincia;
        state.addressObject.codigoProvincia = dir.codigoProvincia;
        state.addressObject.pais = dir.pais;
        state.addressObject.codigoPais = dir.codigoPais;
    },
    /** Esto es en local storage, a depreciar */
    setUltimoPedido(state, data) {
        state.ultimoPedido = data;
        localStorage.setItem('ultimoPedido', JSON.stringify(data));
    },
    setStripeRequireAction(state, a) {
        console.log("action " + a)
        state.stripeRequireAction = a;
    },
    setStripeRequireActionUrl(state, u) {
        state.stripeRequireActionUrl = u;
    },
    setModoEditarDireccion(state, val) {
        state.modoEditarDireccion = val;
    },
    setNewCard(state, val) {
        state.newCard = val;
        if (val != null) state.choosenCard = null;
    },
    setChoosenCard(state, val) {
        state.choosenCard = val;
        if (val != null) state.newCard = null;
    },
    setGuardarTarjeta(state, val) {
        state.guardarTarjeta = val;
    },
    setPedidoMinimo(state, v) {
        state.pedidoMinimo = v;
        localStorage.setItem('pedidoMinimo', v);
    },
    setRecargoPedido(state, v) {
        state.recargoPedido = v;
        localStorage.setItem('recargo', v);
    }
}





